import { useEffect } from "react";
import { useDisclosure } from "@shared/lib/hooks";
import { FilterType } from "../docstore-section-filters/hooks/use-filters";
import { useConfigurableTable } from "./hooks";
import { DocstoreSectionDeleteModal, DocstoreTableAction } from "./ui";
import { ConfigurableTable } from "./ui/configurable-table/configurable-table";
import "./docstore.section.table.scss";

interface DocstoreSectionTableProps {
  filters?: FilterType[];
  searchValue?: string;
}

export function DocstoreSectionTable({
  filters = [],
  searchValue = "",
}: DocstoreSectionTableProps) {
  const {
    isOpen: isDeleteModalOpen,
    onOpen: onDeleteModalOpen,
    onClose: onDeleteModalClose,
  } = useDisclosure();

  const {
    tableConfig,
    loading,
    dataSource,
    handleFiltersChange,
  } = useConfigurableTable((record) => (
    <DocstoreTableAction
      data={record}
      deleteDocument={onDeleteModalOpen}
      deleteStamps={() => {}}
    />
  ));

  useEffect(() => {
    handleFiltersChange(filters, searchValue);
  }, [filters, searchValue, handleFiltersChange]);

  return (
    <>
      <ConfigurableTable
        dataSource={dataSource}
        config={{ columns: tableConfig }}
        loading={loading}
      />

      <DocstoreSectionDeleteModal
        isModalOpen={isDeleteModalOpen}
        handleOk={onDeleteModalClose}
        handleCancel={onDeleteModalClose}
      />
    </>
  );
}
